import React from 'react';

export default class Page6 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <p>Reframing Matrix Example – New product not selling well</p>
                                            <div className="innovativeimg pad-sept">
                                                <img alt=""
                                                     src={require('@images/thought_1.png')}
                                                     className="thought1"/>
                                            </div>
                                            <div className="circle_title separator"><span
                                                className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span
                                                className="heading">NEXT STEPS</span>
                                            </div>
                                            <p>We’ll end with a quick summary of some of the ideas we’ve
                                                given you to reframe problems for success:</p>
                                            <div className="lightgreencontentbg cntareap">
                                                <ul className="greenbullet-list uiheading">
                                                    <li style={{paddingBottom:'9px !important'}}><p>A ‘problem’
                                                        may be an opportunity in disguise; crack it open
                                                        with one or more of the techniques we’ve described,
                                                        under the different headings in this tool:</p></li>
                                                </ul>
                                                <div style={{display: 'table'}}>
                                                    <p className="padleft"><span
                                                        style={{display:'table-row'}}><span
                                                        style={{display: 'table-cell',paddingRight: '5px'}}>–&nbsp;</span><span
                                                        style={{display: 'table-cell'}}> Be aware of the ‘creative process’: &nbsp;1.&nbsp; Insight&nbsp; 2.&nbsp; Ideas&nbsp; 3.&nbsp; Impact</span></span>
                                                    </p>
                                                    <p className="padleft"><span
                                                        style={{display:'table-row'}}><span
                                                        style={{display: 'table-cell',paddingRight: '5px'}}>–&nbsp;</span><span
                                                        style={{display: 'table-cell'}}> State breakers</span></span>
                                                    </p>
                                                    <p className="padleft"><span
                                                        style={{display:'table-row'}}><span
                                                        style={{display: 'table-cell',paddingRight: '5px'}}>–&nbsp;</span><span
                                                        style={{display: 'table-cell'}}> Looking at it from different angles</span></span>
                                                    </p>
                                                    <p className="padleft"><span
                                                        style={{display:'table-row'}}><span
                                                        style={{display: 'table-cell',paddingRight: '5px'}}>–&nbsp;</span><span
                                                        style={{display: 'table-cell'}}>Borrowing ideas</span></span>
                                                    </p>
                                                    <p className="padleft"><span
                                                        style={{display:'table-row'}}><span
                                                        style={{display: 'table-cell',paddingRight: '5px'}}>–&nbsp;</span><span
                                                        style={{display: 'table-cell'}}> Stimuli</span></span>
                                                    </p>
                                                    <p className="padleft"><span
                                                        style={{display:'table-row'}}><span
                                                        style={{display: 'table-cell',paddingRight: '5px'}}>–&nbsp;</span><span
                                                        style={{display: 'table-cell'}}>Using the reframing matrix.</span></span>
                                                    </p>
                                                </div>
                                            </div>
                                            <br/>
                                            <p>By using, remembering and practising these steps you will
                                                have a formidable array of tactics ready to deploy when
                                                a reframing is necessary. Always remember to be ready to
                                                accept that a reframe may be needed and to analyse how
                                                and when to go about it for the best results.</p>
                                            <div
                                                className="lightgreencontentbg uiheading lightbgcenter">
                                                <p>Use mood or ‘state’ breakers to stop your current
                                                    thought process. Find which works best for you.</p>
                                            </div>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done thought"> &lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page7')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}